import React from 'react';
import { Pane, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
export default function PasswordErrorsComponent(props) {
  const {
    value,
    errors,
    validator
  } = props;
  const requirements = validator?.getRequirements();
  if (!requirements) {
    return null;
  }
  const e = Object.values(requirements).map(requirement => {
    const {
      type: code,
      ...rest
    } = requirement;
    if (errors != null) {
      const error = errors.find(err => err.type === code);
      const isError = !error?.valid;
      return /*#__PURE__*/React.createElement(Text, {
        key: code,
        variant: isError ? 'passwordRequirementError' : 'passwordRequirementSuccess'
      }, I18N.t(code, rest));
    }
    if (!value) {
      return /*#__PURE__*/React.createElement(Text, {
        key: code,
        variant: "passwordRequirement"
      }, I18N.t(code, rest));
    }
    return /*#__PURE__*/React.createElement(Text, {
      key: code,
      variant: "passwordRequirementSuccess"
    }, I18N.t(code, rest));
  });
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "passwordRequirements",
    layout: "flex:col"
  }, e);
}